import React from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import ReadingListSlider from "../ReadingListSlider";
import bookLover from "../../illustrations/undraw_book_lover_mkck.svg";

import Typography from "@material-ui/core/Typography";

export default function SearchBookLandingPage() {
  const readingList = useSelector((state) => state.readingList);
  const auth = useSelector((state) => state.auth);

  if (readingList) {
  }

  const RenderLandingPageGraphics = () => {
    return (
      <React.Fragment>
        <div style={{ display: "flex", marginTop: 16, marginBottom: 12 }}>
          <img
            src={bookLover}
            alt={"Seach Books"}
            style={{
              width: "40%",
              margin: "auto",
            }}
          ></img>
        </div>
        <Typography align="center" variant="h5" component="h5">
          Search Books using the search input above.
        </Typography>
      </React.Fragment>
    );
  };

  const RenderReadingListSlider = () => {
    if (auth && auth.uid && readingList && _.keys(readingList).length > 0) {
      return <ReadingListSlider />;
    } else {
      return RenderLandingPageGraphics();
    }
  };

  return <React.Fragment>{RenderReadingListSlider()}</React.Fragment>;
}
